// Central content file — edit copy here to update the site easily.
export const ORG = {
  name: "Consecrated Hands",
  logo: "/img/logo.png",
  ein: "33-4903145",
  taxStatus: "Federally recognized 501(c)(3) public charity",
  donationUrl: process.env.REACT_APP_STRIPE_PAYMENT_LINK || "",
  mission:
    "Consecrated Hands is a Christ-centered mentorship program that guides young people spiritually, educationally, and financially as they overcome life's hardships. We help them grow closer to Christ, build confidence, develop practical life skills, and discover a healthier, more purposeful path forward.",
  contacts: [
  { name: "Justin Mata", title: "Co-Founder & Executive Director", phone: "504-539-1771" },
  { name: "Storm Leigh", title: "Co-Founder & Executive Director", phone: "504-657-6618" },
],
  email: "OurConsecratedHands@Gmail.com",
  socials: [],
};

// The Truth message — core to the ministry's voice.
export const TRUTH = {
  eyebrow: "The Truth We Speak",
  headline: "We show them the lies — and we tell them the Truth.",
  body:
    "The world tells our kids a lie: that they aren't enough. That they're too broken, too late, too far gone. We sit with them, name that lie for what it is, and speak the Truth over their lives — the Truth of Jesus. They are known. They are loved. They were made on purpose, for a purpose.",
  verse: "\"For you formed my inmost being… I praise you, for I am fearfully and wonderfully made.\" — Psalm 139:13–14",
};

// THE 5 PILLARS
export const PILLARS = [
  {
    n: "01",
    title: "Faith",
    desc: "Leading young hearts closer to Christ through discipleship, prayer, and scripture — the foundation everything else is built upon.",
    image: "/img/faith.webp",
  },
  {
    n: "02",
    title: "Family",
    desc: "Building healthy relationships and a sense of belonging, so no young person walks through hardship alone.",
    image: "/img/family.webp",
  },
  {
    n: "03",
    title: "Finance",
    desc: "Practical, biblical stewardship — budgeting, saving, and generosity that break cycles and build a stable future.",
    image: "/img/finance.webp",
  },
  {
    n: "04",
    title: "Fitness",
    desc: "Caring for the body and mind God gave them — discipline, health, and resilience for the whole person.",
    image: "/img/fitness.webp",
  },
  {
    n: "05",
    title: "Future",
    desc: "Casting vision for what's ahead — education, calling, and a life built on purpose rather than survival.",
    image: "/img/future.webp",
  },
];

export const VALUES = [
  { n: "01", title: "Christ at the Center", body: "Everything we do flows from the love of Jesus. We meet young people with grace, truth, and unwavering hope." },
  { n: "02", title: "Every Person Matters", body: "We seek out the ones who need it most — believing each life carries immeasurable, God-given worth." },
  { n: "03", title: "Whole-Life Mentorship", body: "Across all five pillars — Faith, Family, Finance, Fitness, and Future — we walk with youth in every part of their lives." },
  { n: "04", title: "Faithful Stewardship", body: "As a nonprofit, we honor every gift with integrity, transparency, and a focus on lasting impact." },
];

// Animated impact counters
export const IMPACT = [];

export const TESTIMONIALS = [];

export const EVENTS = [];

export const FAQ = [
  {
    q: "Who does Consecrated Hands serve?",
    a: "We mentor young people facing hardship — meeting them wherever they are and walking with them spiritually, educationally, financially, and personally toward a purposeful path in Christ.",
  },
  {
    q: "Is my donation tax-deductible?",
    a: "Consecrated Hands is a Christ-centered 501(c)(3) nonprofit. Contributions may be tax-deductible to the fullest extent allowed by law, and your payment processor will provide a receipt when online giving is enabled.",
  },
  {
    q: "How do I become a mentor?",
    a: "Visit our Mentorship or Volunteer pages and fill out the application. We'll reach out to talk through the next steps, training, and how you can best serve.",
  },
  {
    q: "What are the 5 Pillars?",
    a: "Faith, Family, Finance, Fitness, and Future — five connected areas of growth we build into every young person's life, all rooted in the love and Truth of Jesus.",
  },
  {
    q: "How are donations used?",
    a: "Your gifts fund mentorship, educational resources, community outreach, and faith-based programs that directly support the youth and families in our care.",
  },
];

export const MANIFESTO = [
  "Faith",
  "Family",
  "Finance",
  "Fitness",
  "Future",
  "You are enough in Christ",
];

// Hero background (full-width) — real event photo of a child holding his Bible
export const HERO_BG = "/img/hero.webp";
export const STAINED_GLASS = "/img/faith.webp";
export const IMAGES = {
  heroFaith: "/img/faith.webp",
  stainedGlass: "/img/faith.webp",
  mentorship: "/img/impact.webp",
  youthStudying: "/img/finance.webp",
  youthPortrait: "/img/future.webp",
  volunteering: "/img/serve.webp",
  kidsSun: "/img/about.webp",
  sportsMentor: "/img/mission.webp",
};
